export const useFormatCurrency = (price: number | null): string => (price ? price.toLocaleString("ru-RU", { style: "currency", currency: "RUB", maximumFractionDigits: 0 }) : "null");
